import { ASSETS_API, ASSETS_API_PREFIX } from "config-global";
import { QUESTION_COLUMNS } from "./question-column";
import DataTable from "components/common/data-table/data-table";
import QuestionForm from "./question-form";

interface QuestionProps {
  id: number;
}

const QuestionTable: React.FC<QuestionProps> = ({ id }) => {
  return (
    <div className="mt-5">
      <DataTable
        tableName="Question"
        parentTableName="Step"
        deleteTitle="Question"
        mainCol="questionText"
        getAllLink={`/api/admin/award-steps/${id}`} //TODO add "api" to base rout
        getItemLink="/api/admin/award-step-questions" //TODO add "api" to base rout
        hasCreate={true}
        hasEdit={false}
        hasView={true}
        createItemLink="/api/admin/award-step-questions/answers" //TODO add "api" to base rout
        deleteRowLink="/api/admin/award-step-questions" //TODO add "api" to base rout
        tableCols={QUESTION_COLUMNS}
        FormContent={QuestionForm}
        formDataMapper={(data: any) => {
          return {
            ...data,
            questionImage:
              ASSETS_API + ASSETS_API_PREFIX + data?.questionImageUrl,
          };
        }}
        formSubmitMapper={(data: any) => {
          const formData = new FormData();
          if (!data?.id || data.questionImage) {
            formData.append("questionImage", data.questionImage);
          }
          formData.append("questionText", data?.questionText);
          if (!data?.id) formData.append("questionStep", id.toString());
          data?.answers?.forEach((answer: any, index: number) => {
            formData.append(
              `answers[${index}][answerText]`,
              answer?.answerText
            );
            formData.append(
              `answers[${index}][correctAnswer]`,
              answer?.correctAnswer?.toString()
            );
            formData.append(
              `answers[${index}][answerQuestion]`,
              answer?.answerQuestion
            );
            return formData;
          });
          return formData;
        }}
      />
    </div>
  );
};

export default QuestionTable;
